import { useMemo } from 'react'
import type { FactoryHookType } from '../type'
import maybeCreateSystemCompatibilityFilterNode from './SystemCompatibilityFilterNodeFactory'

const useSystemCompatibilityFilterNode: FactoryHookType = ({ RendererComponent, options }) => {
  return useMemo(() => {
    return maybeCreateSystemCompatibilityFilterNode({
      componentType: options.componentType,
      RendererComponent,
    })
  }, [options.componentType, RendererComponent])
}

export default useSystemCompatibilityFilterNode
